import client, { clientTransformed } from '@common/utils/rest';
import { executeUI } from '@common/utils/ui-bridge';
import { getQueriesAsSearch } from '@common/utils';
import { ROOT_SYSTEM_FIELDS_ID } from '../constants/folders';

const URL_PREFIX = 'api/individuals';
const INDIVIDUALS_ID = 1;

const getUrl = (path) => {
  return `${URL_PREFIX}/${path}`;
};

export const getIndividualsColumns = () => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'GET'
  }).then(
    (response) => {
      return response.entity;
    },
  );
};

export const saveIndividualsColumns = (columns) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns
    },
  });
};

export const individualSearch = (params) => {
  return clientTransformed({
    path: getUrl('search'),
    method: 'GET',
    params,
  }).then(res => res.entity)
};

export const showProbandsOnly = () => {
  return clientTransformed({
    path: getUrl('showProbandsOnly'),
    method: 'GET'
  }).then(response => response.entity);
};

export const checkIndividualNameExists = ({ homeFolderId, name }) => {
  return clientTransformed({
    path: getUrl('checkIndividualNameExists'),
    params: {
      folderId: homeFolderId,
      individualName: name
    },
    method: 'GET',
  }).then(response => response.entity);
};

export const createIndividual = (entity) => {
  return client({
    path: getUrl('createIndividual'),
    entity,
    method: 'POST',
  }).then(response => response.entity);
};

export const applyCurrentColumnsToAllUsers = (columns) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      action: "APPLY_ALL"
    },
  });
};

export const applyCurrentColumnsToSpecificProfiles = (columns, profilesFormat) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      profiles: profilesFormat,
      action: "APPLY_PROFILES"
    },
  });
};

export const setDefaultColumnsForToAllUsers = (columns) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      action: "DEFAULT_ALL"
    },
  });
};

export const setDefaultColumnsForSpecificUsers = (columns, profilesFormat) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      profiles: profilesFormat,
      action: "DEFAULT_PROFILES"
    },
  });
};

export const restoreIndividualsColumnsToDefault = () => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'GET',
    params: {
      default: true
    },
  }).then(
    (response) => {
      return response.entity;
    },
  );
};

const spreadSheetsModuleName = 'SPREADSHEETS';

export const openNewSpreadsheet = (folderId) => {
  executeUI(spreadSheetsModuleName, 'openISS', null, null, folderId);
};

export const validateIndividualEmail = ({ individualId, fhq4, questionnaireId }) => {
	return client({
    path: getUrl('validateInviteIndividualsEmails'),
    method: 'GET',
    params: {
      globalIds: individualId,
      fhq4,
      questionnaireId
    },
  }).then((response) => {
    return response.entity;
  });
};

export const deleteIndividual = (familyId) => {
	return clientTransformed({
    path: getUrl('deletePedigree'),
    method: 'POST',
    params: {
      familyId
    }
  });
};

export const changeIndividualGender = (individualId, gender) => {
	return clientTransformed({
    path: getUrl('changeGender'),
    method: 'POST',
    params: {
      globalId: individualId,
      newGender: gender,
    }
  });
};

export const moveIndividualToExistingPedigree = ({ newFamilyId, oldFamilyId }) => {
  return clientTransformed({
    path: getUrl('moveIndividuals'),
    method: 'POST',
    params: {
      newFamilyId,
      oldFamilyId
    },
  })
};

export const moveIndividualToNewPedigree = ({ familyName, familyId, folderId, individualName }) => {
  return clientTransformed({
    path: getUrl('moveToNewPedigree'),
    method: 'POST',
    params: {
      familyName,
      familyId,
      folderId,
      individualName,
      makeProband: true
    },
  })
};

export const getIndividualSecurity = (familyId) => {
	return clientTransformed({
    path: getUrl('security'),
    method: 'GET',
    params: {
      familyId
    }
  }).then((response) => {
    return response.entity;
  });
};

export const updateIndividualSecurity = (familyId, securityOptions) => {
	return clientTransformed({
    path: getUrl('updateSecurity'),
    method: 'POST',
    params: {
      familyId,
    },
    entity: securityOptions
  });
};

export const transmitEvent = async ({ eventCode, individualId, token }) => {
  return client({
    path: getUrl('transmit'),
    method: 'POST',
		params: {
      globalId: individualId,
      eventCode,
      token,
    },
  }).then((x) => x.entity);
};


export const callAuditIndividualView = async (globalId) => {
    return client({
        path: getUrl('audit'),
        method: 'POST',
        params: {
            globalId: globalId,
        },
    });
};